"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pratola-peligna": {
    "4190724d": [{
      "hkey": "96670829",
      "slug": "bagnaturo",
      "name": "Bagnaturo",
      "primary": true,
      "skipSearch": false
    }],
    "badia-bagnaturo": [{
      "hkey": "96670829",
      "slug": "bagnaturo",
      "name": "Bagnaturo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ef772941": [{
      "hkey": "dcbfabd3",
      "slug": "pratola-peligna",
      "name": "Pratola Peligna",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "dcbfabd3",
      "slug": "pratola-peligna",
      "name": "Pratola Peligna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;